export {default} from "./RegularInput"